<template>
  <div v-if="data">
    <div class="root">
      <img class="invoice-logo" :src="logoUrl" />
      <h1>{{ data.invoiceTitle }}</h1>
      <div v-if="data.invoiceSubTitle" class="sub-title">{{ data.invoiceSubTitle }}</div>
      <h2 v-if="data.objectAddress && data.objectAddress.name">{{ data.projectCode }}, {{ data.objectAddress.name }}</h2>
      <h2 v-else>{{ data.projectCode }}, [Objekt saknas]</h2>

      <div class="float-left">
        <div>
          <template v-if="data.invoiceEmail">
            <div class="invoice-label">Mottagare:</div>
            <div class="value">{{ data.invoiceEmail }}</div>
          </template>
        </div>
        <div>
          <div class="invoice-label">Er märkning:</div>
          <div class="value">
            <template v-if="!data.costCenter">
              [saknas]
            </template>
            <template v-else>
              {{ data.costCenter }}
            </template>
          </div>
        </div>
        <div>
          <div class="invoice-label">Er referens:</div>
          <div class="value">
            <template v-if="!data.customerReferenceName">
              [saknas]
            </template>
            <template v-else>
              {{ data.customerReferenceName }}
            </template>
          </div>
        </div>
        <div>
          <div class="invoice-label">Vårt projektnr:</div>
          <div class="value">{{ data.projectCode }}</div>
        </div>
        <div>
          <div class="invoice-label">Vår referens:</div>
          <div class="value">
            <template v-if="!data.ourReferenceName">
              [saknas]
            </template>
            <template v-else>
              {{ data.ourReferenceName }}
            </template>
          </div>
        </div>
        <div>
          <br>
          <div class="invoice-label">Fakturadatum:</div>
          <div class="value">{{ data.dateCreated | moment("YYYY-MM-DD") }}</div>
        </div>
        <template v-if="data.invoiceType === 'Debit'">
          <div>
            <div class="invoice-label">Bet. villkor:</div>
            <div class="value">{{ data.paymentTermDays }} dagar</div>
          </div>
          <div>
            <div class="invoice-label">Dröjsmålsränta:</div>
            <div class="value">8 %</div>
          </div>
        </template>
      </div>

      <div class="float-left">
        <div class="value address">
          <template v-if="data.invoiceAddress">
            <!--<div>{{ data.invoiceAddress.customerName }}</div>-->
            <div v-if="data.invoiceAddress.name">{{ data.invoiceAddress.name }}</div>
            <div v-if="data.invoiceAddress.address1">{{ data.invoiceAddress.address1 }}</div>
            <div v-if="data.invoiceAddress.address2">{{ data.invoiceAddress.address2 }}</div>
            <div>{{ data.invoiceAddress.postalCode }} {{ data.invoiceAddress.city }}</div>
          </template>
          <template v-else>
            [fakturaadress saknas]
          </template>
        </div>
      </div>

      <br style="clear:both">

      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <!-- INVOICE TABLE -->
      <table class="invoice-table margin-top">

        <thead>
          <tr>
            <th>Beskrivning</th>
            <th>Antal</th>
            <th>Enhetspris</th>
            <th>DELSUMMA</th>
          </tr>
        </thead>

        <tbody>
          <!--
          <tr>
            <td>
              <b class="underline">{{ data.objectLineHeader }}</b>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          -->
          <tr v-for="item in data.items.filter(x => x.productType === 'Rate')" :key="item.sortNum">
            <td :class="{ 'extra-padding-left': !item.invoiceItemGroupHeading }">{{ item.invoiceItemText }}</td>
            <td class="right">{{ formatNumber(item.invoiceableHours) }}</td>
            <td class="right">{{ formatCurrency(item.unitPrice) }}</td>
            <td class="right">{{ formatCurrency(item.subTotal) }}</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <td style="height: 100px"></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>

        <tbody v-if="data.items.some(x => x.productType === 'Rent')">
          <tr v-for="item in data.items.filter(x => x.productType === 'Rent')" :key="item.sortNum">
            <td>{{ item.invoiceItemText }}</td>
            <td class="right">{{ formatNumber(item.quantity) }}</td>
            <td class="right">{{ formatCurrency(item.unitPrice) }}</td>
            <td class="right">{{ formatCurrency(item.subTotal) }}</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <td class="border-top-only invoice-message-td" rowspan="3">
              <div class="invoice-message" v-html="data.invoiceMessage"></div>
            </td>
            <td class="border-top-only"></td>
            <td class="border-top-only text-centered" >Totalt</td>
            <td class="border-all right">{{ formatCurrency(data.sumTotalRounded) }}</td>
          </tr>
          <tr>
            <td class="no-borders"></td>
            <td class="border-all text-centered">Moms 25 %</td>
            <td class="border-all right">{{ formatCurrency(data.vatTotalRounded) }}</td>
          </tr>
          <tr>
            <td v-if="data.invoiceType === 'Debit'" colspan="2" class="bold right no-borders">SUMMA SEK</td>
            <td v-else colspan="2" class="bold right no-borders">Krediteras</td>
            <td class="border-all right bold">{{ formatCurrency(data.sumTotalIncVat) }}</td>
          </tr>
        </tbody>
      </table>
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->
      <!-- /INVOICE TABLE -->

      <div class="footer">
        <template v-if="data.invoiceType === 'Debit'">
          <div class="bold large">Betalning vänligen oss tillhanda senast förfallodagen</div>
          <table class="bold info-table large">
            <tr>
              <td class="no-padding-left">Förfallodag: {{ data.dueDate | moment("YYYY-MM-DD") }}</td>
              <td class="right">Bankgiro: 5474-8397</td>
              <td class="right ocr">OCR: {{ data.ocr }}</td>
            </tr>
          </table>
          <div class="info-box margin-top">
            Vänligen ange OCR-nummer vid betalning.<br />
            Invändningar mot fakturan önskas inom 8 dagar.
          </div>
        </template>
        <table class="info-table small-text border-top margin-top">
          <tr>
            <td style="width: 40%">
              <b>Akustikbyrån T4p AB</b><br />
              Johan Printz väg 7<br />
              121 46 Johanneshov
            </td>
            <td style="width: 30%">
              Telefon: 08-96 33 77<br />
              E-post: info@akustikbyran.com<br />
              Hemsida: www.akustikbyran.com
            </td>
            <td style="width: 30%">
              <div class="float-right">
                Styrelsens säte: Stockholm<br />
                Godkänd för F-skatt<br />
                <!-- Org. nr: 556683-2480 -->
                Momsreg.nr (VAT):<br>SE556683248001
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-layout-buttons :save-label="saveLabel" />
  </div>
</template>

<script>

import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'
import { formatNumber } from '@/helpers'

export default {
  props: {
    data: null,
    logoUrl: null
  },
  components: {
    ModalLayoutButtons
  },
  computed: {
    saveLabel () {
      if (this.data.invoiceType === 'Credit') {
        return 'Skapa kreditfaktura'
      } else {
        return 'Skapa faktura'
      }
    }
  },
  methods: {
    formatNumber (value) {
      return value.toString().replace('.', ',')
    },
    formatCurrency (value) {
      if (!value) {
        return null
      }
      return formatNumber(value) + ' kr'
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.$emit('save')
    })
  }
}
</script>

<!-- component specific -->
<style scoped>
  .root {
    font-family: Verdana;
    font-size: 12px;
    border: 1px solid #999;
    padding: 20px;
    box-shadow: 10px 10px 19px -10px rgba(0, 0, 0, 0.27);
  }
</style>

<!-- shared with pdf -->
<style scoped>
  .ocr {
    font-family: "Courier New", Courier, monospace;
    font-weight: normal;
    font-size: 1rem;
  }
  .no-padding-left {
    padding-left: 0;
  }
  .float-right {
    float: right;
  }
  .float-left {
    float: left;
  }
  .text-centered {
    text-align: center;
  }
  .bold {
    font-weight: bold;
  }
  h1, h2 {
    margin: 0 0 10px 0 !important;
    font-family: Verdana;
  }
  h1 {
    font-size: 2rem;
  }
  h2 {
    font-size: 1.1rem;
  }
  .sub-title {
    margin-bottom: 10px;
  }
  .invoice-label {
    width: 120px;
    display: inline-block;
  }
  .value {
    display: inline-block;
    max-width: 200px;
    width: 200px;
  }
  .address {
    height: 60px;
  }
  .invoice-logo {
    float: right;
    width: 100px;
  }
  .margin-top {
    margin-top: 20px;
  }

  .invoice-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .invoice-table th {
    font-weight: bold;
    text-align: left;
    border: 1px solid #AAA;
    padding: 0 5px;
  }
  .invoice-table td {
    padding: 0;
    text-align: left;
    border-left: 1px solid #AAA;
    border-right: 1px solid #AAA;
    border-top: none;
    border-bottom: none;
    padding: 0 5px;
  }
  .invoice-table td.extra-padding-left {
    padding-left: 15px;
  }
  .invoice-table td.no-borders {
    border: none;
  }
  .invoice-table td.border-all {
    border-left: 1px solid #AAA;
    border-right: 1px solid #AAA;
    border-bottom: 1px solid #AAA;
    border-top: 1px solid #AAA;
  }
  .invoice-table td.border-top-only {
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top: 1px solid #AAA;
  }
  .invoice-table td.right {
    text-align: right;
  }
  .underline {
    text-decoration: underline;
  }
  .small-text {
    font-size: 12px;
  }
  .border-top {
    border-top: 1px solid #ccc;
  }
  .footer {
    font-size: 12px;
  }

  .bold {
    font-weight: bold;
  }

  .large {
    font-size: 0.85rem;
  }

  .bold.info-table.large td {
    line-height: 24px;
  }

  .info-box {
    border: 1px dotted #666;
    font-style: italic;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
  }
  .info-table {
    width: 100%;
  }
  .info-table td.right {
    text-align: right;
  }

  .invoice-table .invoice-message-td {
   width: 50%;
  }

  .invoice-message {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Invoices/InvoicePreview.vue